import React from 'react';

export default function Chart(props) {
  return <section className='column Service__chart'></section>;
}
